/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Reviewcontent1Inputs */

const id_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten Ulasan`)
};

const ms_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kandungan Ulasan`)
};

const da_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldelsesindhold`)
};

const de_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertungsinhalt`)
};

const en_us2_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review Content`)
};

const es_es2_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido de la reseña`)
};

const es_mx2_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido de la reseña`)
};

const fil_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilalaman ng Review`)
};

const fr_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu de l'avis`)
};

const it_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto recensione`)
};

const hu_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelés tartalma`)
};

const nl_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review-inhoud`)
};

const no_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omtaleinnhold`)
};

const pl_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treść recenzji`)
};

const pt_br2_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review Content`)
};

const pt_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo da avaliação`)
};

const ro_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conținutul recenziei`)
};

const fi_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvostelun sisältö`)
};

const sv_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recensionsinnehåll`)
};

const vi_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung đánh giá`)
};

const tr_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum İçeriği`)
};

const cs_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsah recenze`)
};

const bg_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Съдържание на ревюто`)
};

const ru_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Содержание обзора`)
};

const uk_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст відгуку`)
};

const ar_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى المراجعة`)
};

const hi_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा सामग्री`)
};

const th_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เนื้อหารีวิว`)
};

const ja_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビュー内容`)
};

const zh_cn2_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review Content`)
};

const zh_hant1_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review Content`)
};

const ko_forms_review_reviewcontent1 = /** @type {(inputs: Forms_Review_Reviewcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review Content`)
};

/**
* | output |
* | --- |
* | "Review Content" |
*
* @param {Forms_Review_Reviewcontent1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_reviewcontent1 = /** @type {((inputs?: Forms_Review_Reviewcontent1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Reviewcontent1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_reviewcontent1(inputs)
	if (locale === "ms") return ms_forms_review_reviewcontent1(inputs)
	if (locale === "da") return da_forms_review_reviewcontent1(inputs)
	if (locale === "de") return de_forms_review_reviewcontent1(inputs)
	if (locale === "en-US") return en_us2_forms_review_reviewcontent1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_reviewcontent1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_reviewcontent1(inputs)
	if (locale === "fil") return fil_forms_review_reviewcontent1(inputs)
	if (locale === "fr") return fr_forms_review_reviewcontent1(inputs)
	if (locale === "it") return it_forms_review_reviewcontent1(inputs)
	if (locale === "hu") return hu_forms_review_reviewcontent1(inputs)
	if (locale === "nl") return nl_forms_review_reviewcontent1(inputs)
	if (locale === "no") return no_forms_review_reviewcontent1(inputs)
	if (locale === "pl") return pl_forms_review_reviewcontent1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_reviewcontent1(inputs)
	if (locale === "pt") return pt_forms_review_reviewcontent1(inputs)
	if (locale === "ro") return ro_forms_review_reviewcontent1(inputs)
	if (locale === "fi") return fi_forms_review_reviewcontent1(inputs)
	if (locale === "sv") return sv_forms_review_reviewcontent1(inputs)
	if (locale === "vi") return vi_forms_review_reviewcontent1(inputs)
	if (locale === "tr") return tr_forms_review_reviewcontent1(inputs)
	if (locale === "cs") return cs_forms_review_reviewcontent1(inputs)
	if (locale === "bg") return bg_forms_review_reviewcontent1(inputs)
	if (locale === "ru") return ru_forms_review_reviewcontent1(inputs)
	if (locale === "uk") return uk_forms_review_reviewcontent1(inputs)
	if (locale === "ar") return ar_forms_review_reviewcontent1(inputs)
	if (locale === "hi") return hi_forms_review_reviewcontent1(inputs)
	if (locale === "th") return th_forms_review_reviewcontent1(inputs)
	if (locale === "ja") return ja_forms_review_reviewcontent1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_reviewcontent1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_reviewcontent1(inputs)
	return ko_forms_review_reviewcontent1(inputs)
});
export { forms_review_reviewcontent1 as "forms.review.reviewContent" }